import React, { Fragment } from "react";
import { renderCheckbox, renderTextField, renderSelect, renderSlider, renderRangeSlider } from "../../ReduxFormAdapters";
import { Typography, MenuItem, Button, Grid, Icon, Slider } from "@material-ui/core";
import "./ApartmentTypeFields.css"
import DateField from "../../Helpers/DateField";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";

const rentMarks = [
    { value: 0, label: '0€' },
    { value: 2500, label: '2.5k€' },
    { value: 5000, label: '5k€' },
    { value: 7500, label: '7.5k€' },
    { value: 10000, label: '10k€' },
];

const sizeMarks = [
    { value: 0, label: '0 m²' },
    { value: 250, label: '250 m²' },
    { value: 500, label: '500 m²' },
    { value: 750, label: '750 m²' },
    { value: 1000, label: '1000 m²' },
];

const dateMarks = [
    { value: 0, label: 'ASAP' },
    { value: 1, label: '1 mo' },
    { value: 2, label: '2 mo' },
    { value: 3, label: '3 mo' },
    { value: 4, label: '4 mo' },
    { value: 5, label: '5 mo' },
    { value: 6, label: '6+ mo' },
];

const convertSliderToDate = (value) => {
    const date = new Date();
    date.setMonth(date.getMonth() + value);
    return date;
};

const ApartmentTypeFields = (props) => {
    const { landlord, form, setPropertyPics, setSurroundPics, propertyPics, surroundPics, setMoveInDate, mode } = props;
    const isInterior = !mode || mode === "interior";
    const isSecurity = mode === "security";
    const propertyPicCount = propertyPics.length;
    const surroundPicCount = surroundPics.length;
    const tenant = !landlord;
    return (
        <Fragment>
            {landlord && isInterior && (
                <div className="Content-options">
                    <div>
                        <Typography
                            variant="h6"
                            color="secondary"
                            align="left"
                        >
                            Property Types*
                        </Typography>
                        <div className="ApartmentForm-column">
                            <ValidatedField
                                name="residenceType"
                                component={renderSelect}
                            >
                                <MenuItem value="" disabled>Choose the Type of Residence</MenuItem>
                                <MenuItem value="GARAGE">Garage</MenuItem>
                                <MenuItem value="OFFICE">Office</MenuItem>
                                <MenuItem value="ATELIER">Atelier</MenuItem>
                                <MenuItem value="SEWING_WORKSHOP">Sewing workshop</MenuItem>
                                <MenuItem value="CAR_WORKSHOP">Car workshop</MenuItem>
                                <MenuItem value="MASSAGE_WORKSHOP">Massage workshop</MenuItem>
                                <MenuItem value="PRODUCTION_HALL">Production hall</MenuItem>
                            </ValidatedField>
                        </div>
                    </div>
                    <div style={{ visibility: 'hidden', height: 0, width: 0, overflow: 'hidden' }}>
                        {/* Keep fields for tenant state even if not visible in this step?
                            Actually, it's better to just not render them here.
                            They are rendered in TenantPropertyFilters.
                        */}
                    </div>
                </div>
            )}
            {landlord && isInterior && (
                <div className="Content-options">
                    <div style={{ width: '100%' }}>
                        <Typography
                            variant="h6"
                            color="secondary"
                            align="left"
                        >
                            Move in Date*
                        </Typography>
                        <ValidatedField
                            container={DateField}
                            name="moveInDate"
                            form={form}
                            min={Date.now()}
                        />
                    </div>
                </div>
            )}
            {landlord && isInterior && (
                <div>
                    <Typography
                        variant="h6"
                        color="secondary"
                        align="left"
                    >
                        Move out Date
                    </Typography>
                    <ValidatedField
                        container={DateField}
                        name="moveOutDate"
                        form={form}
                        min={Date.now()}
                    />
                </div>
            )}
            {landlord && isInterior && (
                <div className="Content-options">
                    <div style={{ width: '100%' }}>
                        <Typography
                            variant="h6"
                            color="secondary"
                            align="left"
                        >
                            Rent per Month*
                        </Typography>
                        <ValidatedField
                            name="rent"
                            component={renderTextField}
                            variant="outlined"
                            color="secondary"
                            required
                            type="text"
                            placeholder="€"
                        />
                    </div>
                </div>
            )}
            {landlord && isInterior && (
                <div className="Content-options">
                    <div style={{ width: '100%' }}>
                        <Typography
                            variant="h6"
                            color="secondary"
                            align="left"
                        >
                            Size (m²)*
                        </Typography>
                        <ValidatedField
                            name="size"
                            component={renderTextField}
                            variant="outlined"
                            color="secondary"
                            required
                            type="text"
                            placeholder="m²"
                        />
                    </div>
                </div>
            )}
            {isInterior && (
                <Fragment>
                    <Typography
                        variant="h6"
                        color="secondary"
                        align="left"
                        className="ApartmentTypeFields-header"
                    >
                        Property Characteristics
                    </Typography>
                </Fragment>
            )}
            <div className="Content-options">
                {isInterior && (
                    <div style={{ width: '100%' }}>
                        <div className="ApartmentForm-checkbox-grid">
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="kitchen"
                                label="Kitchen"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="waterTap"
                                label="Water Tap"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="wc"
                                label="Toilet / Bathroom"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="shower"
                                label="Shower"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="breakRoom"
                                label="Break Room"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="meetingRoom"
                                label="Meeting Room"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="lounge"
                                label="Lounge Room"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="lighting"
                                label="Lighting"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="naturalLight"
                                label="Natural Light"
                            />
                        </div>
                    </div>
                )}
                {isSecurity && (
                    <div style={{ width: '100%' }}>
                        <div className="ApartmentForm-checkbox-grid">
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="driveIn"
                                label="Drive-in with car possible"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="controlRoom24h"
                                label="24/7 Control Room"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="cameraSurveillance24h"
                                label="24/7 Video Surveillance"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="parking"
                                label="Parking Possible"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="buildingInsurance"
                                label="Building Insurance Included"
                            />
                            <ValidatedField
                                component={renderCheckbox}
                                color="primary"
                                name="smartLock"
                                label="Smart Lock (in exterior doors)"
                            />
                        </div>
                    </div>
                )}
            </div>
            {
                landlord &&
                <Fragment>
                    <div className="Content-options">
                        <ValidatedField
                            name="propertyPics"
                            required
                            component="span"
                            hidden
                        />
                        <input
                            onChange={(e) => {
                                e.preventDefault();
                                const files = e.target.files;
                                setPropertyPics(files);
                            }}
                            accept="image/png"
                            id="propertypics-upload-button"
                            type="file"
                            multiple
                            hidden
                        />
                        <label htmlFor="propertypics-upload-button">
                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                component="span"
                            >
                                Upload Pictures
                            </Button>
                        </label>
                        {
                            Boolean(propertyPicCount) &&
                            <Button
                                variant="text"
                                color="secondary"
                                size="large"
                                onClick={() => setPropertyPics([])}
                            >
                                <Icon>delete</Icon>&nbsp;Remove {propertyPicCount} pictures
                            </Button>
                        }
                    </div>
                    <div className="ApartmentForm-filelist">
                        {
                            propertyPics.map((name, i) => (
                                <div key={i} className="ApartmentForm-filelist-container">
                                    <div>{name}</div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="Content-options">
                        <ValidatedField
                            name="surroundPics"
                            required
                            component="span"
                            hidden
                        />
                        <input
                            onChange={(e) => {
                                e.preventDefault();
                                const files = e.target.files;
                                setSurroundPics(files);
                            }}
                            accept="image/png"
                            id="surroundPics-upload-button"
                            type="file"
                            multiple
                            hidden
                        />
                        <label htmlFor="surroundPics-upload-button">
                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                component="span"
                            >
                                Upload 360 Pictures
                            </Button>
                        </label>
                        {
                            Boolean(surroundPicCount) &&
                            <Button
                                variant="text"
                                color="secondary"
                                size="large"
                                onClick={() => setSurroundPics([])}
                            >
                                <Icon>delete</Icon>&nbsp;Remove {surroundPicCount} pictures
                            </Button>
                        }
                    </div>
                    <div className="ApartmentForm-filelist">
                        {
                            surroundPics.map((name, i) => (
                                <div key={i} className="ApartmentForm-filelist-container">
                                    <div>{name}</div>
                                </div>
                            ))
                        }
                    </div>
                </Fragment>
            }
            {landlord &&
                <Fragment>
                    <Typography
                        variant="body1"
                        color="secondary"
                    >
                        Please Write a Short Description About the property Below (max 300 characters)
                    </Typography>
                    <ValidatedField
                        name="description"
                        component={renderTextField}
                        multiline
                        margin="normal"
                        rowsMax="3"
                        type="text"
                    />
                </Fragment>
            }
        </Fragment>
    );
}

export default connect(
    (state, ownProps) => {
        const selector = formValueSelector(ownProps.form);
        const propertyPics = selector(state, "propertyPics");
        const surroundPics = selector(state, "surroundPics");
        const propertyFiles = [];
        const surroundFiles = [];
        if (propertyPics && propertyPics.item) {
            for (let i = 0; i < propertyPics.length; i++) {
                propertyFiles.push(propertyPics.item(i).name)
            }
        }
        if (surroundPics && surroundPics.item) {
            for (let i = 0; i < surroundPics.length; i++) {
                surroundFiles.push(surroundPics.item(i).name)
            }
        }
        return {
            propertyPics: propertyFiles,
            surroundPics: surroundFiles
        };
    },
    (dispatch, ownProps) => ({
        setPropertyPics: (files) => dispatch(change(ownProps.form, 'propertyPics', files)),
        setSurroundPics: (files) => dispatch(change(ownProps.form, 'surroundPics', files)),
        setMoveInDate: (date) => dispatch(change(ownProps.form, 'moveInDate', date))
    })
)(ApartmentTypeFields);

